import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export type CalloutTone = "warn" | "neutral";

interface Props {
  tone?: CalloutTone;
  icon?: ReactNode;
  children: ReactNode;
}

/** Tokens de cada tono; son colores fijos del diseño, no varían por tenant. */
const TONE_TOKENS = {
  warn: { bg: "warningSoftBg", border: "warningSoftBorder" },
  neutral: { bg: "neutralSoftBg", border: "neutralSoftBorder" },
} as const;

export const Callout = ({ tone = "neutral", icon, children }: Props) => (
  <Box
    sx={{
      display: "flex",
      borderRadius: 3,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: (theme) => theme.palette.tokens?.[TONE_TOKENS[tone].border],
      bgcolor: (theme) => theme.palette.tokens?.[TONE_TOKENS[tone].bg],
      px: 2,
      py: 1,
      gap: 1,
    }}
  >
    {icon}
    {/* `div` y no `p`: los consumidores a veces pasan bloques (checkbox + texto, otro Typography) y un
        `<p>` dentro de otro `<p>` es HTML inválido. */}
    <Typography component="div" variant="body2" color="text.secondary">
      {children}
    </Typography>
  </Box>
);
